import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../../common/SafeIcon';
import { FiGift, FiZap } from 'react-icons/fi';

export const Bonus = () => {
  return (
    <section className="py-24 px-4 bg-gradient-to-b from-[#0B0E14] to-navy-900">
      <div className="max-w-4xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-5xl font-bold text-white mb-4">
            Today's Financial Year End <span className="text-gold-400">Bonuses</span>
          </h2>
          <p className="text-gray-400 text-lg">Available only with today's offer</p>
        </div>

        <motion.div 
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="bg-gradient-to-br from-gold-500/10 to-gold-700/5 border border-gold-500/30 rounded-3xl p-8 md:p-12 relative overflow-hidden"
        >
          {/* Shine effect */}
          <div className="absolute top-0 -left-[100%] w-1/2 h-full bg-gradient-to-r from-transparent via-white/10 to-transparent skew-x-12 animate-[shine_3s_infinite]"></div>
          
          <div className="relative z-10 flex flex-col md:flex-row items-center gap-8">
            <div className="w-24 h-24 bg-gold-500/20 rounded-2xl flex items-center justify-center shrink-0 border border-gold-500/30">
              <SafeIcon icon={FiGift} className="text-5xl text-gold-400" />
            </div>
            
            <div className="text-center md:text-left">
              <div className="inline-block bg-gold-500/20 text-gold-400 text-sm font-bold px-3 py-1 rounded-full mb-3 border border-gold-500/30">
                BONUS 1
              </div>
              <h3 className="text-2xl md:text-3xl font-bold text-white mb-2">
                1 Month FREE FunnelsDone Business Plan
              </h3>
              <p className="text-gold-400/80 font-medium text-lg">Worth ₹10,000 + GST</p>
            </div>
          </div>

          <div className="w-full h-px bg-gradient-to-r from-transparent via-gold-500/20 to-transparent my-8"></div>

          <div className="relative z-10 flex flex-col md:flex-row items-center gap-8">
            <div className="w-24 h-24 bg-royal-500/20 rounded-2xl flex items-center justify-center shrink-0 border border-royal-500/30">
              <SafeIcon icon={FiZap} className="text-5xl text-royal-400" />
            </div>
            
            <div className="text-center md:text-left">
               <div className="inline-block bg-royal-500/20 text-royal-400 text-sm font-bold px-3 py-1 rounded-full mb-3 border border-royal-500/30">
                BONUS 2
              </div>
              <h3 className="text-2xl md:text-3xl font-bold text-white mb-2">
                Vibe Coding Included
              </h3>
              <p className="text-royal-400/80 font-medium text-lg">Accelerate your implementation</p>
            </div>
          </div>
        </motion.div>
        
        <style dangerouslySetInnerHTML={{__html: `
          @keyframes shine {
            100% { left: 200%; }
          }
        `}} />
      </div>
    </section>
  );
};